var _path, _path2, _path3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuxiferLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 32,
    viewBox: "0 0 135 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0417 7.24V21.4H46.0497V25H35.1537V7.24H39.0417ZM87.0885 7.24V25H83.2005V7.24H87.0885ZM100.922 18.064H94.6823V25H90.7943V7.24H102.098V10.84H94.6823V14.56H100.922V18.064ZM116.043 25H104.763V7.24H116.043V10.84H108.651V14.32H115.203V17.728H108.651V21.4H116.043V25ZM123.112 25H119.224V7.24H126.088C130.408 7.24 132.856 9.328 132.856 13C132.856 15.304 131.872 16.936 129.904 17.944L133.024 25H128.776L126.112 18.784H123.112V25ZM123.112 10.696V15.376H126.064C127.768 15.376 128.752 14.512 128.752 13C128.752 11.512 127.816 10.696 126.088 10.696H123.112Z",
    fill: "#1F1F24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.643 18.328V7.24H51.531V18.064C51.531 20.296 52.755 21.52 54.939 21.52C57.147 21.52 58.395 20.248 58.395 18.064V7.24H62.283V18.328C62.283 22.552 59.403 25.288 54.939 25.288C50.499 25.288 47.643 22.576 47.643 18.328ZM70.3688 16.12L64.6568 7.24H69.2888L70.7768 9.568C71.4248 10.576 72.0488 11.656 72.8408 13.12L76.3928 7.24H80.9288L75.3128 16.12L80.9288 25H76.3208L75.1448 23.152C74.2568 21.736 73.6808 20.68 72.8168 19.096L69.0008 25H64.4408L70.3688 16.12Z",
    fill: "#2A00FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61406 2.29596C10.0406 1.89674 10.7023 1.90221 11.1289 2.30143C12.6383 3.71784 14.0547 5.24362 15.3781 6.89518C15.9797 6.10768 16.6633 5.24909 17.4016 4.54909C17.8336 4.1444 18.5008 4.1444 18.9328 4.55456C20.825 6.35924 22.4273 8.74362 23.5539 11.0077C24.6641 13.2389 25.4023 15.5194 25.4023 17.1272C25.4023 24.1053 19.9445 30.0007 13.1523 30.0007C6.28359 30.0007 0.902344 24.0999 0.902344 17.1217C0.902344 15.0217 1.87578 12.4569 3.38516 9.9194C4.91094 7.34362 7.06563 4.65846 9.61406 2.29596ZM13.2453 24.7507C14.6289 24.7507 15.8539 24.3678 17.0078 23.6022C19.3102 21.9944 19.9281 18.7788 18.5445 16.2522C18.2984 15.76 17.6695 15.7272 17.3141 16.1428L15.9359 17.7452C15.575 18.1608 14.9242 18.1499 14.5852 17.7178C13.6828 16.5694 12.0695 14.5186 11.1508 13.3538C10.8062 12.9163 10.15 12.9108 9.8 13.3483C7.95156 15.6725 7.02187 17.1382 7.02187 18.7842C7.02734 22.5303 9.79453 24.7507 13.2453 24.7507Z",
    fill: "#1F1F24"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9855,
    cy: 19.151,
    r: 1.16667,
    fill: "#1F1F24"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.3683,
    cy: 19.151,
    r: 1.16667,
    fill: "#1F1F24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuxiferLogo);
export default __webpack_public_path__ + "static/media/luxifer-logo.b4f195357b74df5688aa2bd6bbd9c3f3.svg";
export { ForwardRef as ReactComponent };